import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MatSidenavModule} from '@angular/material/sidenav';
import {
  HomeLoanComponent,
  BusinessAutoComponent,
  ConsumerAutoComponent,
  OnlineQuoteComponent,
  BrokerQuotesComponent,
} from './forms/index';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatToolbarModule} from '@angular/material/toolbar';
import {
  AbnSearchPartialComponent,
  CarSearchPartialComponent,
  DialogPartialComponent,
  CrumbsSearchPartialComponent,
  ValidationPartialComponent,
} from './widgets/partials/index';
import {
  AbnDataDialogComponent,
  AccountantDetailsComponent
} from './widgets/accountant-details/accountant-details.component';
import {WizardFormComponent} from './forms/wizard-form.component';
import {WizardWidgetComponent} from './widgets/wizard-widget/wizard-widget.component';
import {TrustDetailsComponent} from './widgets/trust-details/trust-details.component';
import {AutoCollateralComponent} from './widgets/auto-collateral/auto-collateral.component';
import {SubmitComponent} from './widgets/submit/submit.component';
import {DocumentUploadComponent} from './widgets/documents-upload/documents-upload.component';
import {FileUploadModule} from 'ng2-file-upload';
import {InsuranceDetailsComponent} from './widgets/insurance-details/insurance-details.component';
import {ConfirmationComponent} from './widgets/confirmation/confirmation.component';
import {IncomeDetailsComponent} from './widgets/income-details/income-details.component';
import {AssetsDetailsComponent} from './widgets/assets-details/assets-details.component';
import {LiabilitiesDetailsComponent} from './widgets/liabilities-details/liabilities-details.component';
import {ExpensesDetailsComponent} from './widgets/expense-details/expenses-details.component';
import {RateComponent} from './widgets/rate/rate.component';
import {BrokerNotesComponent} from './widgets/broker-notes/broker-notes.component';
import {ProductComponent} from './widgets/product/product.component';
import {InvestmentIncomeComponent} from './widgets/investment-income/investment-income.component';
import {EmploymentDetailsComponent} from './widgets/employment-details/employment-details.component';
import {environment} from '../../environments/environment';
import {BorrowerTypeEnhancedComponent} from './widgets/borrower-type-enhanced/borrower-type-enhanced.component';
import {AddressSuggestionsComponent} from './widgets/address-suggestions/address-suggestions.component';
import {OwnershipAllocationComponent} from './widgets/ownership-allocation/ownership-allocation.component';
import {SelfEmployedDetailsComponent} from './widgets/self-employed-details/self-employed-details.component';
import {BasActivityDetailsComponent} from './widgets/bas-activity-details/bas-activity-details.component';
import {
  AbnAcnComponent, ApplicationTypeComponent,
  BalloonAmountComponent,
  BorrowerTypeComponent,
  BusinessCarLoanDetailsComponent,
  CompanyDetailsComponent,
  CustomerDetailsComponent,
  LoanDetailsComponent, LoanDetailsTermsComponent,
  LoanTermsComponent, HomeLoanDetailsComponent,
  OriginatorBrokerComponent,
  PersonalDetailsComponent,
  QuoteDetailsComponent,
  QuoteResultsComponent, QuoteResultsDialogComponent, QuotesListComponent, SecurityDetailsComponent,
  SingleSplitLoanAmountComponent, SolicitorBorrowerDetailsComponent, SolicitorPanelDetailsComponent
} from './widgets';
import {ControlRequiredPipe} from '../_global/pipes/control-required.pipe';
import {MatListModule} from '@angular/material/list';
import {MatProgressBarModule} from '@angular/material/progress-bar';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatCardModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatListModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatSlideToggleModule,
    FileUploadModule,
    BusinessAutoComponent,
    ConsumerAutoComponent,
    HomeLoanComponent,
    OnlineQuoteComponent,
    BrokerQuotesComponent,
    OriginatorBrokerComponent,
    CustomerDetailsComponent,
    AbnAcnComponent,
    BorrowerTypeComponent,
    BorrowerTypeEnhancedComponent,
    ValidationPartialComponent,
    CarSearchPartialComponent,
    CrumbsSearchPartialComponent,
    BusinessCarLoanDetailsComponent,
    CompanyDetailsComponent,
    AbnSearchPartialComponent,
    AccountantDetailsComponent,
    PersonalDetailsComponent,
    DialogPartialComponent,
    AbnDataDialogComponent,
    WizardFormComponent,
    WizardWidgetComponent,
    TrustDetailsComponent,
    LoanDetailsComponent,
    SingleSplitLoanAmountComponent,
    InsuranceDetailsComponent,
    LoanTermsComponent,
    BalloonAmountComponent,
    AutoCollateralComponent,
    DocumentUploadComponent,
    SubmitComponent,
    ConfirmationComponent,
    IncomeDetailsComponent,
    EmploymentDetailsComponent,
    InvestmentIncomeComponent,
    AssetsDetailsComponent,
    LiabilitiesDetailsComponent,
    ExpensesDetailsComponent,
    QuoteDetailsComponent,
    QuoteResultsComponent,
    QuoteResultsDialogComponent,
    QuotesListComponent,
    LoanDetailsTermsComponent,
    ApplicationTypeComponent,
    HomeLoanDetailsComponent,
    SecurityDetailsComponent,
    SolicitorPanelDetailsComponent,
    SolicitorBorrowerDetailsComponent,
    RateComponent,
    ProductComponent,
    BrokerNotesComponent,
    AddressSuggestionsComponent,
    OwnershipAllocationComponent,
    SelfEmployedDetailsComponent,
    BasActivityDetailsComponent,
    ControlRequiredPipe
  ],
  exports: [
    BusinessAutoComponent,
    ConsumerAutoComponent,
    HomeLoanComponent,
    OnlineQuoteComponent,
    BrokerQuotesComponent,
    AddressSuggestionsComponent,
    OwnershipAllocationComponent,
    SelfEmployedDetailsComponent,
    BasActivityDetailsComponent,
    MatAutocompleteModule,
    MatCardModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatListModule,
    MatSelectModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule
  ],
  providers: [
    ControlRequiredPipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class WizardApplicationModule {
  static forRoot(): ModuleWithProviders<WizardApplicationModule> {
    return {
      ngModule: WizardApplicationModule
    };
  }
}
